module.exports = __webpack_public_path__ + "media/images/pic/courses/6-7714e0895f84e9884c949c9aac4ccdef.jpeg";